<div class="disclaimer-wrap">
  <div class="disclaimer-title">Disclaimer</div>
  <mat-icon class="close-btn cursor-pointer" (click)="close()">close</mat-icon>
  <div class="disclaimer-content">{{message}}</div>
</div>